export default "__VITE_ASSET__DHI_fuZO__"